(() => {
    const containerStates = new WeakMap();
    let activeStoreContainer = null;

    const CARRIER_SKU_PREFIXES = {
        Bell: 'HWBE',
        Rogers: 'HWRO',
        Fido: 'HWRO',
        Virgin: 'HWBE'
    };

function isVariantAvailableForCarrier(variant, carrier) {
    const normalizedCarrier = String(carrier || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '');

    const prefix = Object.entries(CARRIER_SKU_PREFIXES)
        .find(([name]) =>
            name.toLowerCase() === normalizedCarrier
        )?.[1];

    if (!prefix) {
        return false;
    }

    return String(variant.sku || '')
        .split(/\s+/)
        .some(sku =>
            sku.toUpperCase().startsWith(prefix)
        );
}

    function isFrench() {
        return document.documentElement.lang
            .toLowerCase()
            .startsWith('fr');
    }

    function getState(container) {
        if (!containerStates.has(container)) {
            containerStates.set(container, {
                variants: [],
                selectedStore: null,
                pendingStore: null
            });
        }

        return containerStates.get(container);
    }

    function parseVariants(container) {
        const element = container.querySelector(
            '[data-preorder-variants]'
        );

        if (!element) {
            return [];
        }

        try {
            return JSON.parse(element.textContent);
        } catch (error) {
            console.error(
                'Unable to parse preorder variants:',
                error
            );

            return [];
        }
    }

    /*
     * Change these field mappings after inspecting the
     * object returned by Store Locator Widgets.
     */
    function normalizeStore(store) {
        if (!store) {
            return null;
        }

        const storeData = store.data || {};

        // console.log(storeData)

        /*
        * French Store Locator custom field IDs.
        */
        const frenchStreet =
            storeData[
                '274262d47b42508659de0d1c2d3852ab'
            ] || '';

        const frenchLocality =
            storeData[
                '58e506aa6f2a3f3418ee426f46aecfad'
            ] || '';

        const frenchStoreName =
            storeData[
                '823cfad53ef5ce977f557b0623421a25'
            ] || '';

        const storeId = storeData['1a960e45927541718a3da96c18d774cb'] || '';

        /*
        * English uses data.address.
        * French separates the address into two custom fields.
        */
        const address =
            storeData.address ||
            [frenchStreet, frenchLocality]
                .filter(Boolean)
                .join(', ');

        return {
            id: String(store.storeid || ''),
            locatorId: String(store.id || ''),

            name: String(
                store.name ||
                frenchStoreName ||
                ''
            ),

            address: String(address),

            storeId: Number(storeId),

            website: String(
                storeData.website || ''
            )
        };
    }

    function findVariant(container, storage, colour) {
        if (!storage || !colour) {
            return null;
        }

        const state = getState(container);

        const carrierSelect = container.querySelector(
            '[data-preorder-carrier]'
        );

        const carrier = carrierSelect?.value || '';

        if (!carrier) {
            return null;
        }

        const storageIndex = Number(
            container.dataset.storageOptionIndex
        );

        const colourIndex = Number(
            container.dataset.colourOptionIndex
        );

        if (
            storageIndex < 0 ||
            colourIndex < 0
        ) {
            return null;
        }

        return (
            state.variants.find(variant => {
                return (
                    isVariantAvailableForCarrier(
                        variant,
                        carrier
                    ) &&
                    variant.options?.[storageIndex] === storage &&
                    variant.options?.[colourIndex] === colour
                );
            }) || null
        );
    }

    function updateStorageOptions(container) {
        const state = getState(container);

        const carrierSelect = container.querySelector(
            '[data-preorder-carrier]'
        );

        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        if (!carrierSelect || !storageSelect) {
            return;
        }

        const carrier = carrierSelect.value;
        const previousStorage = storageSelect.value;

        const storageIndex = Number(
            container.dataset.storageOptionIndex
        );

        const placeholder =
            storageSelect.dataset.placeholder ||
            'Choose a storage';

        const storages = [
            ...new Set(
                state.variants
                    .filter(variant =>
                        isVariantAvailableForCarrier(
                            variant,
                            carrier
                        )
                    )
                    .map(variant =>
                        variant.options?.[storageIndex]
                    )
                    .filter(Boolean)
            )
        ];

        storageSelect.replaceChildren();

        storageSelect.add(
            new Option(placeholder, '')
        );

        storages.forEach(storage => {
            storageSelect.add(
                new Option(storage, storage)
            );
        });

        if (storages.includes(previousStorage)) {
            storageSelect.value = previousStorage;
        } else if (storages.length === 1) {
            storageSelect.value = storages[0];
        } else {
            storageSelect.value = '';
        }

        storageSelect.disabled =
            !carrier || storages.length === 0;

        updateColourOptions(container);
        synchronizeVariant(container);
    }

    function updateColourOptions(
        container,
        preferredColour = ''
    ) {
        const state = getState(container);

        const carrierSelect = container.querySelector(
            '[data-preorder-carrier]'
        );

        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        const colourSelect = container.querySelector(
            '[data-preorder-colour]'
        );

        if (!carrierSelect || !storageSelect || !colourSelect) {
            return;
        }

        const carrier = carrierSelect.value;
        const storage = storageSelect.value;

        const storageIndex = Number(
            container.dataset.storageOptionIndex
        );

        const colourIndex = Number(
            container.dataset.colourOptionIndex
        );

        const previousColour =
            preferredColour || colourSelect.value;

        const placeholder =
            colourSelect.dataset.placeholder ||
            'Choose a colour';

        const colours = [
            ...new Set(
                state.variants
                    .filter(variant => {
                        return (
                            isVariantAvailableForCarrier(
                                variant,
                                carrier
                            ) &&
                            variant.options?.[storageIndex] === storage
                        );
                    })
                    .map(variant =>
                        variant.options?.[colourIndex]
                    )
                    .filter(Boolean)
            )
        ];

        colourSelect.replaceChildren();

        colourSelect.add(
            new Option(placeholder, '')
        );

        colours.forEach(colour => {
            colourSelect.add(
                new Option(colour, colour)
            );
        });

        if (colours.includes(previousColour)) {
            colourSelect.value = previousColour;
        } else if (colours.length === 1) {
            colourSelect.value = colours[0];
        } else {
            colourSelect.value = '';
        }

        colourSelect.disabled =
            !carrier ||
            !storage ||
            colours.length === 0;
    }

    function synchronizeVariant(container) {
        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        const colourSelect = container.querySelector(
            '[data-preorder-colour]'
        );

        const variant = findVariant(
            container,
            storageSelect?.value || '',
            colourSelect?.value || ''
        );

        container.dataset.phoneVariantId =
            variant?.id || '';

        return variant;
    }

    function setDropdownsFromVariant(
        container,
        variant
    ) {
        if (!variant?.options) {
            return;
        }

        const storageIndex = Number(
            container.dataset.storageOptionIndex
        );

        const colourIndex = Number(
            container.dataset.colourOptionIndex
        );

        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        const selectedStorage =
            variant.options[storageIndex] || '';

        const selectedColour =
            variant.options[colourIndex] || '';

        if (storageSelect && storageIndex >= 0) {
            storageSelect.value =
                selectedStorage;
        }

        /*
        * Rebuild the colour dropdown using the
        * selected variant's storage and colour.
        */
        updateColourOptions(
            container,
            selectedColour
        );

        container.dataset.phoneVariantId =
            variant.id;
    }

    function getSelection(container) {
        const state = getState(container);

        const carrierSelect = container.querySelector(
            '[data-preorder-carrier]'
        );

        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        const colourSelect = container.querySelector(
            '[data-preorder-colour]'
        );

        return {
            container,
            phone: container.dataset.phoneTitle,
            phoneProductId: container.dataset.phoneProductId,
            phoneVariantId: container.dataset.phoneVariantId,
            depositVariantId: container.dataset.depositVariantId,
            storage: storageSelect?.value || '',
            colour: colourSelect?.value || '',
            carrier: carrierSelect?.value || '',
            store: state.selectedStore
        };
    }

    function updateButton(container) {
        const selection = getSelection(container);

        const button = container.querySelector(
            '[data-preorder-button]'
        );

        const message = container.querySelector(
            '[data-preorder-message]'
        );

        const complete = Boolean(
            selection.phoneVariantId &&
            selection.storage &&
            selection.colour &&
            selection.carrier &&
            selection.store?.id &&
            selection.store?.name
        );

        if (button) {
            button.disabled = !complete;
        }

        if (message) {
            message.hidden = complete;
        }
    }

    function openPreorderPanel(container) {
        const panel = container.querySelector(
            '[data-preorder-panel]'
        );

        const openButton = container.querySelector(
            '[data-preorder-open]'
        );

        if (!panel || !openButton) {
            return;
        }

        filterCarrierOptions(container);
        updateStorageOptions(container);

        panel.hidden = false;
        openButton.hidden = true;

        openButton.setAttribute(
            'aria-expanded',
            'true'
        );

        updateButton(container);
    }

    function closePreorderPanel(container) {
        const panel = container.querySelector(
            '[data-preorder-panel]'
        );

        const openButton = container.querySelector(
            '[data-preorder-open]'
        );

        if (!panel || !openButton) {
            return;
        }

        /*
        * Also close the store locator if it happens
        * to be open.
        */
        const storeModal = container.querySelector(
            '[data-preorder-store-modal]'
        );

        if (storeModal && !storeModal.hidden) {
            closeStoreModal(container);
        }

        panel.hidden = true;
        openButton.hidden = false;

        openButton.setAttribute(
            'aria-expanded',
            'false'
        );

        openButton.focus();
    }

    function openStoreModal(container) {
        const modal = container.querySelector(
            '[data-preorder-store-modal]'
        );

        if (!modal) {
            return;
        }

        activeStoreContainer = container;
        modal.hidden = false;

        document.documentElement.classList.add(
            'preorder-store-modal-open'
        );

        /*
         * A map initialized while hidden sometimes needs
         * a resize event after becoming visible.
         */
        requestAnimationFrame(() => {
            window.dispatchEvent(
                new Event('resize')
            );
        });
    }

    function closeStoreModal(container) {
        const modal = container.querySelector(
            '[data-preorder-store-modal]'
        );

        if (modal) {
            modal.hidden = true;
        }

        document.documentElement.classList.remove(
            'preorder-store-modal-open'
        );

        activeStoreContainer = null;
    }

    function showPendingStore(container, store) {
        const confirmation = container.querySelector(
            '[data-preorder-store-confirmation]'
        );

        const name = container.querySelector(
            '[data-preorder-pending-store-name]'
        );

        const address = container.querySelector(
            '[data-preorder-pending-store-address]'
        );

        if (name) {
            name.textContent = store.name;
        }

        if (address) {
            address.textContent = store.address;
        }

        if (confirmation) {
            confirmation.hidden = false;
        }
    }

    function confirmStore(container) {
        const state = getState(container);

        if (!state.pendingStore) {
            return;
        }

        state.selectedStore = state.pendingStore;

        const selectedStore = container.querySelector(
            '[data-preorder-selected-store]'
        );

        const selectButton = container.querySelector(
            '[data-preorder-store-open]'
        );

        const name = container.querySelector(
            '[data-preorder-store-name]'
        );

        const address = container.querySelector(
            '[data-preorder-store-address]'
        );

        if (name) {
            name.textContent = state.selectedStore.name;
        }

        if (address) {
            address.textContent = state.selectedStore.address;
        }

        if (selectedStore) {
            selectedStore.hidden = false;
        }

        if (selectButton) {
            selectButton.hidden = true;
        }

        closeStoreModal(container);
        updateButton(container);
    }

    function getSelectedProvince() {
        try {
            return String(
                localStorage.getItem('ProvinceValue') || ''
            )
            .trim()
            .replace(/^["']|["']$/g, '')
            .toLowerCase();
        } catch (error) {
            console.warn(
                'Unable to read ProvinceValue:',
                error
            );

            return '';
        }
    }

    function filterCarrierOptions(container) {
        const carrierSelect = container.querySelector(
            '[data-preorder-carrier]'
        );

        if (!carrierSelect) {
            return;
        }

        const province = getSelectedProvince();
        const showSaskTel = province === 'sk';

        Array.from(carrierSelect.options).forEach(
            option => {
                const carrierName = option.value
                    .trim()
                    .toLowerCase()
                    .replace(/\s+/g, '');

                if (carrierName !== 'sasktel') {
                    return;
                }

                option.hidden = !showSaskTel;
                option.disabled = !showSaskTel;

                /*
                * Clear SaskTel if it was previously selected
                * and the province is no longer Saskatchewan.
                */
                if (
                    !showSaskTel &&
                    option.selected
                ) {
                    carrierSelect.value = '';
                }
            }
        );
    }

    function initializeContainer(container) {
        const state = getState(container);

        state.variants = parseVariants(container);

        const storageSelect = container.querySelector(
            '[data-preorder-storage]'
        );

        const colourSelect = container.querySelector(
            '[data-preorder-colour]'
        );

        if (storageSelect) {
            storageSelect.value = '';
        }

        if (colourSelect) {
            colourSelect.value = '';
        }

        container.dataset.phoneVariantId = '';

        /*
        * Hide SaskTel unless ProvinceValue is "sk".
        */
        filterCarrierOptions(container);

        /*
        * Filter storage and colour based on carrier SKUs.
        */
        updateStorageOptions(container);

        updateButton(container);
    }

    function initialize() {
        document.querySelectorAll(
                '[data-preorder-container]'
            )
            .forEach(initializeContainer);
    }

    /*
     * Preserve another Store Locator handler if the
     * page already has one.
     */
    const previousStoreSelectedHandler = window.storeLocatorStoreSelectedHandler;

    window.storeLocatorStoreSelectedHandler = function (store) {
        if (
            typeof previousStoreSelectedHandler === 'function'
        ) {
            previousStoreSelectedHandler(store);
        }

        if (!activeStoreContainer) {
            return;
        }

        const normalizedStore = normalizeStore(store);

        if (
            !normalizedStore?.name || !normalizedStore?.id
        ) {
            console.error(
                'The selected store is missing a store name or stable store ID.',
                store
            );

            return;
        }

        const state = getState(
            activeStoreContainer
        );

        state.pendingStore = normalizedStore;

        showPendingStore(
            activeStoreContainer,
            normalizedStore
        );
    };

    /*
     * Keep compatibility with the existing theme
     * size/colour controls.
     */
    // document.addEventListener(
    //     'variant:change',
    //     event => {
    //         const selectedVariant =
    //             event.detail?.variant;

    //         if (!selectedVariant) {
    //             return;
    //         }

    //         document
    //             .querySelectorAll(
    //                 '[data-preorder-container]'
    //             )
    //             .forEach(container => {
    //                 const state =
    //                     getState(container);

    //                 const mappedVariant =
    //                     state.variants.find(
    //                         variant => {
    //                             return (
    //                                 String(variant.id) ===
    //                                 String(
    //                                     selectedVariant.id
    //                                 )
    //                             );
    //                         }
    //                     );

    //                 if (mappedVariant) {
    //                     setDropdownsFromVariant(
    //                         container,
    //                         mappedVariant
    //                     );

    //                     updateButton(container);
    //                 }
    //             });
    //     }
    // );

    /*
     * Carrier, storage or colour dropdown change.
     */
/*
 * Carrier, storage or colour dropdown change.
 */
    document.addEventListener(
        'change',
        event => {
            if (!event.target.matches(
                [
                    '[data-preorder-carrier]',
                    '[data-preorder-storage]',
                    '[data-preorder-colour]'
                ].join(',')
            )) {
                return;
            }

            const container = event.target.closest(
                '[data-preorder-container]'
            );

            if (!container) {
                return;
            }

            /*
            * Carrier changed:
            * Rebuild storage and colour options.
            */
            if (event.target.matches(
                '[data-preorder-carrier]'
            )) {
                updateStorageOptions(container);
            }

            /*
            * Storage changed:
            * Rebuild available colours.
            */
            if (event.target.matches(
                '[data-preorder-storage]'
            )) {
                updateColourOptions(container);
                synchronizeVariant(container);
            }

            /*
            * Colour changed:
            * Synchronize the selected variant.
            */
            if (event.target.matches(
                '[data-preorder-colour]'
            )) {
                synchronizeVariant(container);
            }

            updateButton(container);
        }
    );

    document.addEventListener('click', async event => {
            const openButton = event.target.closest(
                '[data-preorder-open]'
            );

            if (openButton) {
                const container =
                    openButton.closest(
                        '[data-preorder-container]'
                    );

                openPreorderPanel(container);
                return;
            }

            const closeButton = event.target.closest(
                '[data-preorder-close]'
            );

            if (closeButton) {
                const container =
                    closeButton.closest(
                        '[data-preorder-container]'
                    );

                if (container) {
                    closePreorderPanel(container);
                }

                return;
            }

            const storeOpenButton =
                event.target.closest(
                    [
                        '[data-preorder-store-open]',
                        '[data-preorder-store-change]'
                    ].join(',')
                );

            if (storeOpenButton) {
                const container =
                    storeOpenButton.closest(
                        '[data-preorder-container]'
                    );

                openStoreModal(container);
                return;
            }

            const storeCloseButton =
                event.target.closest(
                    '[data-preorder-store-close]'
                );

            if (storeCloseButton) {
                const container =
                    storeCloseButton.closest(
                        '[data-preorder-container]'
                    );

                closeStoreModal(container);
                return;
            }

            const storeConfirmButton =
                event.target.closest(
                    '[data-preorder-store-confirm]'
                );

            if (storeConfirmButton) {
                const container =
                    storeConfirmButton.closest(
                        '[data-preorder-container]'
                    );

                confirmStore(container);
                return;
            }

            const button = event.target.closest(
                '[data-preorder-button]'
            );

            if (!button) {
                return;
            }

            const container = button.closest(
                '[data-preorder-container]'
            );

            const selection = getSelection(container);

            if (
                !selection.phoneVariantId ||
                !selection.storage ||
                !selection.colour ||
                !selection.carrier ||
                !selection.store?.id
            ) {
                updateButton(container);
                return;
            }

            const message = container.querySelector(
                '[data-preorder-message]'
            );

            button.disabled = true;
            button.textContent = button.dataset.loadingText;

            try {
                const response = await fetch(
                    `${window.Shopify.routes.root}cart/add.js`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type':
                                'application/json'
                        },
                        body: JSON.stringify({
                            items: [
                                {
                                    id: Number(
                                        selection
                                            .depositVariantId
                                    ),
                                    quantity: 1,
                                    properties: {
                                        Phone: selection.phone,
                                        Storage: selection.storage,
                                        Colour: selection.colour,
                                        Carrier: String(selection.carrier || "").trim().replace(/\s+/g, " "),
                                        'Pickup store': selection.store.name,
                                        'Pickup store address': selection.store.address,
                                        '_storelocator_storeid': selection.store.storeId,
                                        '_storelocator_location_id': selection.store.locatorId,
                                        '_pickup_store_url': selection.store.website,
                                        '_phone_product_id': selection.phoneProductId,
                                        '_phone_variant_id': selection.phoneVariantId,
                                        '_reservation_type': 'phone_preorder_deposit'
                                    }
                                }
                            ]
                        })
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Cart request failed: ${response.status}`
                    );
                }

                window.location.assign(
                    `${window.Shopify.routes.root}checkout`
                );
            } catch (error) {
                console.error(
                    'Unable to start pre-order checkout:',
                    error
                );

                button.textContent =
                    button.dataset.defaultText;

                if (message) {
                    message.hidden = false;
                    message.textContent =
                        isFrench()
                            ? 'Impossible de démarrer le paiement. Veuillez réessayer.'
                            : 'Unable to start checkout. Please try again.';
                }

                button.disabled = false;
            }
        }
    );

    document.addEventListener('keydown', event => {
        if (
            event.key !== 'Escape' ||
            !activeStoreContainer
        ) {
            return;
        }

        closeStoreModal(activeStoreContainer);
    });

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initialize
        );
    } else {
        initialize();
    }
})();